import orderInstance from '../instance'

const updateBeeperConfigs = (data) => {
  return orderInstance.put('/beeperConfigs', data)
}

export default updateBeeperConfigs
